import React, { useEffect, useState } from "react";
import {
  Row,
  Col,
  Form,
  Label,
  FormGroup,
  Card,
  CardBody,
  Modal,
  ModalBody,
  ModalHeader,
  ModalFooter,
} from "reactstrap";

import Icon from "react-icons-kit";
import { ic_check } from "react-icons-kit/md/ic_check";
import { ic_close } from "react-icons-kit/md/ic_close";

import "react-toastify/dist/ReactToastify.css";
import CartTitle from "../CartTitle";
import DesignCard from "../DesignCard";
import CustomButton from "../CustomButton";
import { ToastContainer, toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import history from "../../history";
import AddNewExperience from "../AddNewExperience";
import config from "../../utils/config";
import get from "lodash/get";
import UpdateModerationModal from "../UpdateModerationModal";
import InputText from "../InputText";
import { approveRejectUpdatedExperienceDetails } from "../../redux/moderation/experience/actions";

export default function ExperienceDetails(props) {
  const _ = { get };
  const dispatch = useDispatch();
  const { usertype } = useSelector((state) => state.Auth);
  const { elements } = useSelector((state) => state.Elements);
  const [toggleAddModal, setToggleAddModal] = useState(false);
  const [expModal, setExpModal] = useState(false);
  const [rejectionReason, setRejectionReason] = useState("");
  const [rejectionReasonToggle, setRejectionReasonToggle] = useState(false);
  const { fetchingUpdatedDetails, updatedDetails } = useSelector(
    (state) => state.Experience
  );
  useEffect(() => {
    if (props.selectedId) {
      props.handleGetDetails(props.selectedId, "EXPERIENCE");
    }
  }, [props.selectedId]);

  const handleGoBack = () => {
    props.handleToggleModel();
    props.handleBackCall();
  };

  const handleBackCallOnSubmit = () => {
    // setRejectionReasonToggle(!rejectionReasonToggle);
    props.handleGetDetails(props.selectedId, "EXPERIENCE");
  };

  const handleRejectModalOnSubmit = () => {
    setRejectionReasonToggle(!rejectionReasonToggle);
    props.handleGetDetails(props.selectedId, "EXPERIENCE");
  };

  const handleEdit = () => {
    setToggleAddModal(true);
  };

  const handleUpdate = () => {
    history.push(`/moderation/experiences-edit?id=${props.selectedId}`);
  };

  const handleModalPreview = () => {
    setExpModal(!expModal);
    props.handleGetDetails(props.selectedId, "EXPERIENCE");
  };

  const approveOnClick = () => {
    let data = {
      wanderlustId: props.selectedId,
      status: "APPROVED",
      key: "ALL",
      category: "EXPERIENCE",
    };
    dispatch(
      approveRejectUpdatedExperienceDetails(data, handleBackCallOnSubmit)
    );
  };

  const rejectionOnSubmit = () => {
    let data = {
      wanderlustId: props.selectedId,
      status: "REJECTED",
      rejectionReason: rejectionReason,
      key: "ALL",
      category: "EXPERIENCE",
    };
    if (rejectionReason !== "") {
      dispatch(
        approveRejectUpdatedExperienceDetails(data, handleRejectModalOnSubmit)
      );
    }
  };

  useEffect(() => {
    if (
      updatedDetails &&
      updatedDetails.changes &&
      updatedDetails.changes.length === 0 &&
      updatedDetails &&
      updatedDetails.changesGallery &&
      Object.keys(updatedDetails.changesGallery).length === 0
    ) {
      handleModalPreview();
    }
  }, [updatedDetails]);

  return (
    <React.Fragment>
      <div className="hideSearch mt-4">
        <Form>
          <Row>
            {usertype && usertype === "EU Tours Admin" ? (
              <Col sm={12}>
                <CartTitle
                  title={`${props &&
                    props.tourDetails &&
                    props.tourDetails.name} by ${props &&
                    props.tourDetails &&
                    props.tourDetails.partnerId &&
                    props.tourDetails.partnerId.name}`}
                  iconClass={"hideexcel"}
                  customClass={"hidebtn"}
                  innerTextClass={"hidetext"}
                />
              </Col>
            ) : (
              <Col sm={12}>
                <CartTitle
                  title={`${props &&
                    props.tourDetails &&
                    props.tourDetails.name}`}
                  iconClass={"hideexcel"}
                  customClass={"hidebtn"}
                  innerTextClass={"hidetext"}
                />
              </Col>
            )}
          </Row>
          <Card className="mb-3">
            <CardBody>
              {usertype &&
                (usertype === "EU Tours Admin" || usertype === "Admin") && (
                  <Row>
                    <Col md="12">
                      <h2 className="title-bar secondary-title font-weight-bold my-3 pb-2 themeColor">
                        <span>
                          {_.get(
                            elements,
                            "euToursElement.expDetailElement.partnerHeadingElement",
                            "Partner Detail"
                          )}
                        </span>
                      </h2>
                    </Col>
                    <Col
                      xl={12}
                      lg={12}
                      md={6}
                      sm={6}
                      className="mb-4 mt-3 d-flex align-items-start justify-content-between updateBox"
                    >
                      <DesignCard
                        name={_.get(
                          elements,
                          "euToursElement.expDetailElement.nameLabel",
                          "Name"
                        )}
                        titleName={
                          props &&
                          props.tourDetails &&
                          props.tourDetails.partnerId &&
                          props.tourDetails.partnerId.name
                            ? props.tourDetails.partnerId.name
                            : "N/A"
                        }
                      />
                      {props &&
                        props.tourDetails &&
                        props.tourDetails.moderationStatus === "MODIFIED" && (
                          <CustomButton
                            customType={"button"}
                            name="Update"
                            customClass={
                              "btn-outline-dark bg-none btnthemeColor partner_p_button"
                            }
                            customClick={() => {
                              handleModalPreview();
                            }}
                          />
                        )}
                    </Col>
                    <Col xl={3} lg={4} md={6} sm={6} className="mb-4 mt-3">
                      <DesignCard
                        name={_.get(
                          elements,
                          "euToursElement.expDetailElement.emailLabel",
                          "Email"
                        )}
                        titleName={
                          props &&
                          props.tourDetails &&
                          props.tourDetails.partnerId &&
                          props.tourDetails.partnerId.email
                            ? props.tourDetails.partnerId.email
                            : "N/A"
                        }
                      />
                    </Col>
                  </Row>
                )}
              <Row>
                <Col md="12">
                  <h2 className="mb-4 mt-3 d-flex align-items-start justify-content-between updateBox title-bar secondary-title font-weight-bold my-3 pb-2 themeColor">
                    <span>
                      {_.get(
                        elements,
                        "euToursElement.expDetailElement.expDetailHeadingElement",
                        "Experience Detail"
                      )}
                    </span>
                    {usertype &&
                      usertype === "EU Tours Partner" &&
                      props &&
                      props.tourDetails &&
                      props.tourDetails.moderationStatus === "MODIFIED" && (
                        <CustomButton
                          customType={"button"}
                          name="Update"
                          customClass={
                            "btn-outline-dark bg-none btnthemeColor partner_p_button"
                          }
                          customClick={() => {
                            handleModalPreview();
                          }}
                        />
                      )}
                  </h2>
                </Col>
                <Col xl={3} lg={4} md={6} sm={6} className="mb-4 mt-3">
                  <DesignCard
                    name={_.get(
                      elements,
                      "euToursElement.expDetailElement.nameLabel",
                      "Name"
                    )}
                    titleName={
                      props && props.tourDetails && props.tourDetails.name
                        ? props.tourDetails.name
                        : "N/A"
                    }
                  />
                </Col>
                <Col xl={3} lg={4} md={6} sm={6} className="mb-4 mt-3">
                  <DesignCard
                    name={_.get(
                      elements,
                      "euToursElement.expDetailElement.startLocationLabel",
                      "Start Location"
                    )}
                    titleName={
                      props &&
                      props.tourDetails &&
                      props.tourDetails.startPoint &&
                      props.tourDetails.startPoint.name
                        ? props.tourDetails.startPoint.name
                        : "N/A"
                    }
                  />
                </Col>
                <Col xl={3} lg={4} md={6} sm={6} className="mb-4 mt-3">
                  <DesignCard
                    name={_.get(
                      elements,
                      "euToursElement.expDetailElement.startLoactionLatitudeLabel",
                      "Start Location Latitude"
                    )}
                    titleName={
                      props &&
                      props.tourDetails &&
                      props.tourDetails.startPoint &&
                      props.tourDetails.startPoint.latitude
                        ? props.tourDetails.startPoint.latitude
                        : "N/A"
                    }
                  />
                </Col>
                <Col xl={3} lg={4} md={6} sm={6} className="mb-4 mt-3">
                  <DesignCard
                    name={_.get(
                      elements,
                      "euToursElement.expDetailElement.startLocationLongitudeLabel",
                      "Start Location Longitude"
                    )}
                    titleName={
                      props &&
                      props.tourDetails &&
                      props.tourDetails.startPoint &&
                      props.tourDetails.startPoint.longitude
                        ? props.tourDetails.startPoint.longitude
                        : "N/A"
                    }
                  />
                </Col>
                <Col xl={3} lg={4} md={6} sm={6} className="mb-4 mt-3">
                  <DesignCard
                    name={_.get(
                      elements,
                      "euToursElement.expDetailElement.endLocation",
                      "End Location"
                    )}
                    titleName={
                      props &&
                      props.tourDetails &&
                      props.tourDetails.endPoint &&
                      props.tourDetails.endPoint.name
                        ? props.tourDetails.endPoint.name
                        : "N/A"
                    }
                  />
                </Col>
                <Col xl={3} lg={4} md={6} sm={6} className="mb-4 mt-3">
                  <DesignCard
                    name={_.get(
                      elements,
                      "euToursElement.expDetailElement.endLocationLatitudeLabel",
                      "End Location Latitude"
                    )}
                    titleName={
                      props &&
                      props.tourDetails &&
                      props.tourDetails.endPoint &&
                      props.tourDetails.endPoint.latitude
                        ? props.tourDetails.endPoint.latitude
                        : "N/A"
                    }
                  />
                </Col>
                <Col xl={3} lg={4} md={6} sm={6} className="mb-4 mt-3">
                  <DesignCard
                    name={_.get(
                      elements,
                      "euToursElement.expDetailElement.endLocationLongitudeLabel",
                      "End Location Longitude"
                    )}
                    titleName={
                      props &&
                      props.tourDetails &&
                      props.tourDetails.endPoint &&
                      props.tourDetails.endPoint.longitude
                        ? props.tourDetails.endPoint.longitude
                        : "N/A"
                    }
                  />
                </Col>
                <Col xl={3} lg={4} md={6} sm={6} className="mb-4 mt-3">
                  <DesignCard
                    name={_.get(
                      elements,
                      "euToursElement.expDetailElement.startDateLabel",
                      "Start Date"
                    )}
                    titleName={
                      props && props.tourDetails && props.tourDetails.startDate
                        ? props.tourDetails.startDate
                        : "N/A"
                    }
                  />
                </Col>
                <Col xl={3} lg={4} md={6} sm={6} className="mb-4 mt-3">
                  <DesignCard
                    name={_.get(
                      elements,
                      "euToursElement.expDetailElement.endDateLabel",
                      "End Date"
                    )}
                    titleName={
                      props && props.tourDetails && props.tourDetails.endDate
                        ? props.tourDetails.endDate
                        : "N/A"
                    }
                  />
                </Col>
                <Col xl={3} lg={4} md={6} sm={6} className="mb-4 mt-3">
                  <DesignCard
                    name={_.get(
                      elements,
                      "euToursElement.expDetailElement.regionLabel",
                      "Region"
                    )}
                    titleName={
                      props && props.tourDetails && props.tourDetails.region
                        ? props.tourDetails.region
                        : "N/A"
                    }
                  />
                </Col>
                <Col xl={3} lg={4} md={6} sm={6} className="mb-4 mt-3">
                  <DesignCard
                    name={_.get(
                      elements,
                      "euToursElement.expDetailElement.countryLabel",
                      "Country"
                    )}
                    titleName={
                      props && props.tourDetails && props.tourDetails.country
                        ? props.tourDetails.country
                        : "N/A"
                    }
                  />
                </Col>
                <Col xl={3} lg={4} md={6} sm={6} className="mb-4 mt-3">
                  <DesignCard
                    name={_.get(
                      elements,
                      "euToursElement.expDetailElement.distanceCoveredLabel",
                      "Estimated Distance Covered (KM)"
                    )}
                    titleName={
                      props &&
                      props.tourDetails &&
                      props.tourDetails.totalDistance
                        ? props.tourDetails.totalDistance
                        : "N/A"
                    }
                  />
                </Col>
                <Col xl={12} className="mb-4 mt-3">
                  <DesignCard
                    name={_.get(
                      elements,
                      "euToursElement.expDetailElement.descriptionLabel",
                      "Description"
                    )}
                    titleName={
                      props &&
                      props.tourDetails &&
                      props.tourDetails.description
                        ? props.tourDetails.description
                        : "N/A"
                    }
                  />
                </Col>
                <Col xl={12} className="mb-4 mt-3">
                  <DesignCard
                    name={_.get(
                      elements,
                      "euToursElement.expDetailElement.redirectionUrlLabel",
                      "Redirection Url"
                    )}
                    titleName={
                      props &&
                      props.tourDetails &&
                      props.tourDetails.redirectionUrl
                        ? props.tourDetails.redirectionUrl
                        : "N/A"
                    }
                  />
                </Col>
                {/* <Col xl={12} className="mb-4 mt-3">
                  <DesignCard
                    name="Description"
                    titleName={
                      props &&
                      props.tourDetails &&
                      props.tourDetails.description
                    }
                  />
                </Col> */}
              </Row>

              <Row>
                <Col md="12">
                  <h2 className="title-bar secondary-title font-weight-bold my-3 pb-2 themeColor">
                    <span>
                      {_.get(
                        elements,
                        "euToursElement.expDetailElement.mediaHeading",
                        "Media"
                      )}
                    </span>
                  </h2>
                </Col>

                <Col xl={3} lg={4} md={6} sm={6} className="mb-4 mt-3">
                  <div className="image_heading">
                    {_.get(
                      elements,
                      "euToursElement.expDetailElement.thumbnailImageHeading",
                      "Experience Landing Page - Thumbnail - Common  (160 x 190 px)"
                    )}
                  </div>
                  {props &&
                  props.tourDetails &&
                  props.tourDetails.thumbnailImage ? (
                    <img
                      className="image_tour2"
                      src={`${config.imageBaseUrl}/${props &&
                        props.tourDetails &&
                        props.tourDetails.thumbnailImage}
                    `}
                      alt="img"
                    />
                  ) : (
                    "N/A"
                  )}
                </Col>
                <Col xl={3} lg={4} md={6} sm={6} className="mb-4 mt-3">
                  <div className="image_heading">
                    {_.get(
                      elements,
                      "euToursElement.expDetailElement.thumbnailPartnerDetailImageHeading",
                      " Partner Detail Page - Experience Listing Thumbnail - Common - (360 x 310 px)"
                    )}
                  </div>
                  {props &&
                  props.tourDetails &&
                  props.tourDetails.thumbnailImage ? (
                    <img
                      className="image_tour2"
                      src={`${config.imageBaseUrl}/${props &&
                        props.tourDetails &&
                        props.tourDetails.thumbnailPartnerImage}
                    `}
                      alt="img"
                    />
                  ) : (
                    "N/A"
                  )}
                </Col>
              </Row>
              <Row>
                <Col md={12} className="mt-4 mb-2">
                  <div className="image_heading">
                    {_.get(
                      elements,
                      "euToursElement.expDetailElement.galleryImageHeading",
                      "Gallery Images Desktop"
                    )}
                  </div>
                </Col>
              </Row>
              <Row>
                {props && props.tourDetails && props.tourDetails.gallery ? (
                  props.tourDetails.gallery.map((item) => (
                    <Col xl={3} lg={4} md={6} sm={6} className="mb-4 mt-3">
                      <div>
                        <img
                          className="image_tour2"
                          src={`${config.imageBaseUrl}/${item}`}
                          alt="img"
                        />
                      </div>
                    </Col>
                  ))
                ) : (
                  <Col xl={3} lg={4} md={6} sm={6} className="mb-4 mt-3">
                    N/A
                  </Col>
                )}
              </Row>

              <div className="d-flex justify-content-center justify-content-lg-end position-relative mt-5">
                <CustomButton
                  customType={"button"}
                  name={_.get(
                    elements,
                    "euToursElement.expDetailElement.backLabel",
                    "Back"
                  )}
                  customClass={"btn-outline-dark bg-none btnthemeColor"}
                  customClick={(e) => handleGoBack(e)}
                />
                <CustomButton
                  customType={"button"}
                  name={_.get(
                    elements,
                    "euToursElement.expDetailElement.editLabel",
                    "Update"
                  )}
                  customClass={"btn-outline-dark bg-none ml-3 btnthemeColor"}
                  customClick={(e) => handleEdit(e)}
                />
                {usertype &&
                  (usertype === "EU Tours Admin" || usertype === "Admin") && (
                    <CustomButton
                      customType={"button"}
                      name={_.get(
                        elements,
                        "euToursElement.expDetailElement.moderateLabel",
                        "Moderate"
                      )}
                      customClass={
                        "btn-outline-dark bg-none ml-3 btnthemeColor"
                      }
                      customClick={(e) => handleUpdate(e)}
                    />
                  )}
                {usertype &&
                  (usertype === "EU Tours Admin" || usertype === "Admin") && (
                    <CustomButton
                      customType={"button"}
                      name={_.get(
                        elements,
                        "euToursElement.expDetailElement.deleteLabel",
                        "Delete"
                      )}
                      customClass={
                        "btn-outline-dark bg-none ml-3 btnthemeColor"
                      }
                      customClick={() => props.handleRejectModal()}
                    />
                  )}
              </div>
            </CardBody>
          </Card>
        </Form>
        <Modal
          isOpen={toggleAddModal}
          toggle={() => setToggleAddModal(!toggleAddModal)}
          backdrop={true}
          centered={true}
          size="xl"
          className="modal_main"
        >
          <ModalBody>
            <AddNewExperience
              handleToggleModel={() => setToggleAddModal(!toggleAddModal)}
              toursDetails={props.tourDetails}
              formType={
                usertype &&
                (usertype === "EU Tours Admin" || usertype === "Admin")
                  ? "create"
                  : "update"
              }
            />
          </ModalBody>
        </Modal>
        <Modal
          isOpen={expModal}
          toggle={() => handleModalPreview()}
          className="update_preview_modal"
          centered
          scrollable
          size="lg"
        >
          <ModalHeader className="d-block">
            <div className="d-flex justify-content-between flex-column flex-lg-row light-border-bottom header-bg main-title align-items-center py-2 px-2 rounded">
              <div className="CartTitle d-flex align-items-center  justify-content-lg-start justify-content-center">
                <h4 className="text-light text-capitalize m-0 ml-2">
                  <span>Experience Personal Information</span>
                </h4>
              </div>
            </div>
          </ModalHeader>
          <ModalBody>
            <UpdateModerationModal
              wanderlustId={props && props.tourDetails && props.tourDetails._id}
              category={"Experience"}
              handleBackCallOnSubmit={handleBackCallOnSubmit}
            />
          </ModalBody>
          <ModalFooter>
            <CustomButton
              customType={"button"}
              name="Close"
              customClass={"btn-outline-dark bg-none btnthemeColor"}
              customClick={() => handleModalPreview()}
            />
            {usertype &&
              (usertype === "EU Tours Admin" || usertype === "Admin") &&
              updatedDetails &&
              (updatedDetails.changes || updatedDetails.gallery) && (
                <CustomButton
                  customType={"button"}
                  name="Approve All"
                  customClass={"btn-outline-dark bg-none btnthemeColor"}
                  customClick={() => approveOnClick()}
                />
              )}
            {usertype &&
              (usertype === "EU Tours Admin" || usertype === "Admin") &&
              updatedDetails &&
              (updatedDetails.changes || updatedDetails.gallery) && (
                <CustomButton
                  customType={"button"}
                  name="Reject All"
                  customClass={"btn-outline-dark bg-none btnthemeColor"}
                  customClick={() =>
                    setRejectionReasonToggle(!rejectionReasonToggle)
                  }
                />
              )}
          </ModalFooter>
        </Modal>
        <Modal isOpen={rejectionReasonToggle} backdrop={true} centered={true}>
          <ModalHeader
            toggle={() => {
              setRejectionReasonToggle(!rejectionReasonToggle);
              setRejectionReason("");
            }}
          >
            {_.get(
              elements,
              "euToursElement.partnerPersonalInfoElement.rejectionModelLabel",
              "Rejection Reason"
            )}
          </ModalHeader>
          <ModalBody>
            <InputText
              inputType={"textarea"}
              inputName={"rejectionReason"}
              customValue={rejectionReason}
              customOnChange={(e) => setRejectionReason(e.target.value)}
            />
          </ModalBody>
          <ModalFooter>
            <CustomButton
              customType={"submit"}
              name={_.get(
                elements,
                "euToursElement.partnerPersonalInfoElement.rejectElement",
                "Reject"
              )}
              customClass={"btn-outline-dark bg-none ml-2 btnthemeColor"}
              customClick={(e) => rejectionOnSubmit(e)}
            />
          </ModalFooter>
        </Modal>
      </div>
    </React.Fragment>
  );
}
